/**
 * Validate year
 *
 * @param {String} year
 *
 * @return {boolean}
 */
export function isYearValidation(year) {
    return isNaN(year) || year < 1900 || !/^[0-9]{4}$/.test(year) ? 'validation.error.not_a_year' : '';
}



// WEBPACK FOOTER //
// ./src/utils/isYearValidation.js